import { render, staticRenderFns } from "./ListRegionais.vue?vue&type=template&id=6d3245fb"
import script from "./ListRegionais.vue?vue&type=script&lang=js"
export * from "./ListRegionais.vue?vue&type=script&lang=js"
import style0 from "./ListRegionais.vue?vue&type=style&index=0&id=6d3245fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports